export default __webpack_public_path__ + "static/flag-uk-b98886ca3ac7eb0bd2870ca40a8467cf.png";